import { createColumnHelper } from "@tanstack/react-table";
import editIcon from '../../../assets/images/editIcon.svg'
import eyeIcon from '../../../assets/images/eye.svg'
import pendingIcon from '../../../assets/images/pendingsymbol.svg'
import deleteIcon from '../../../assets/images/trash.svg'
import placeOrderIcon from '../../../assets/images/Order-place.svg'
import linkIcon from '../../../assets/images/link.svg'
import unlinkIcon from '../../../assets/images/unlink.svg'
import DeclineModalComponent from "../../../components/Modals/DeclineModalComponent";
import DeclineModalCompanyComponent from "../../../components/Modals/DeclineModalCompanyComponent";

const columnHelper = createColumnHelper();
const ActiveCompanyColumns = (
  acticeViewFun,
  isCancelModalOpen,
  onDeleteCompnyBtnClick,
  t
) => [
  {
    accessorKey: "orderType",
    header: "Order Type", //t('addBusiness.companyName')
  },
  {
    accessorKey: "purchaseProducts.productQuantity", // Custom ID for the column
    header: "Product Quantity", //t("addBusiness.country"),
  },
  {
    accessorKey: "orderStatus", // Custom ID for the column
    header: "Order Status", //t("addBusiness.state"),
  },

  {
    accessorKey: "isDelivered",
    header: "Currenr Delivery Status", //t("addBusiness.city"),
    // cell: lastNameCellFn
  },
  {
    accessorKey: "isCancelled",
    header: "Order Status", //t("addBusiness.zip"),
    // filterFn: firstNameFilterFn
  },
  {
    accessorKey: "deliveryAddressDetails.city",
    header: "City", //t("addBusiness.parent"),
    // filterFn: firstNameFilterFn
  },
  {
    accessorKey: "deliveryAddressDetails.pinCode",
    header: "PinCode", //t("addBusiness.parent"),
    // filterFn: firstNameFilterFn
  },
  {
    accessorKey: "deliveryAddressDetails.timing.startDate",
    header: "StartDate", //t("addBusiness.parent"),
    // filterFn: firstNameFilterFn
  },
  {
    accessorKey: "deliveryAddressDetails.timing.deliveryTime",
    header: "Delivery time", //t("addBusiness.parent"),
    // filterFn: firstNameFilterFn
  },

  {
    accessorKey: "action",
    header: t("OrdersTableText.Action"),
    cell: ({ row }) => {
      // <button onClick={() => navigateCallback(row.original.orderId)}>
      //     Go to Details
      // </button>
      const companyRowData = row.original;
      console.log(
        "------------------------------------------------------------",
        row.original
      );
      return (
        <div className="d-flex clays-sm">
          {/* <button
            className="icon-clay"
            onClick={() => acticeViewFun(companyRowData.companyId)}
          >
            <span className="inner-clay color-black">
              <img src={eyeIcon} alt="View" />
            </span>
          </button>
          <button
            className="icon-clay delete"
            onClick={() =>
              onDeleteCompnyBtnClick(companyRowData.companyId, "delete")
            }
            title="Delete Company"
          >
            <img src={deleteIcon} alt="Delete" />
          </button> */}
          <DeclineModalCompanyComponent
          isOpen={isCancelModalOpen}
          onClose={() => onClose}
          orderId={row.original.companyId}
          forModule='Orders'
        />
          {/* <button className="icon-clay">
            <span className="inner-clay color-red"><img src={xIcon} alt="Delete" /></span>
          </button>*/}
        </div>
      );
    },
  },
];
const ParentCompanyColumns = (handleLinkCompany, handleUnLinkCompany, linkedCompanyId, t
) => [
  {
    accessorKey: 'companyName',
    header: t('addBusiness.companyName')

  },
  {
    accessorKey: 'action',
    header: t('addBusiness.Action'),
    cell: ({ row }) => {
      console.log(
        "_Linked____",
        row.original.companyId,
        "linkedCompanyId ::",
        linkedCompanyId,
        
      );
      return (
        <>
          {linkedCompanyId === row.original.companyId ? (
            <button
              style={{ border: "unset", background: "unset" }}
              onClick={() => handleUnLinkCompany(row.original.companyId, "link")}
            >
              Unlink
            </button>
          ) : (
            <button
              style={{ border: "unset", background: "unset" }}
              onClick={() => handleLinkCompany(row.original, "link")}
            >
              Link
            </button>
          )}
        </>
      );
    },
  },
];
const PendingCompanyColumns = (
  pendingViewFun,
  isCancelModalOpen,
  onDeleteCompnyBtnClick,
  t
) => [
  {
    accessorKey: "orderType",
    header: "Order Type", //t('addBusiness.companyName')
  },
  {
    accessorKey: "purchaseProducts.productQuantity", // Custom ID for the column
    header: "Product Quantity", //t("addBusiness.country"),
  },
  {
    accessorKey: "orderStatus", // Custom ID for the column
    header: "Order Status", //t("addBusiness.state"),
  },

  {
    accessorKey: "isDelivered",
    header: "Currenr Delivery Status", //t("addBusiness.city"),
    // cell: lastNameCellFn
  },
  {
    accessorKey: "isCancelled",
    header: "Order Status", //t("addBusiness.zip"),
    // filterFn: firstNameFilterFn
  },
  {
    accessorKey: "deliveryAddressDetails.city",
    header: "City", //t("addBusiness.parent"),
    // filterFn: firstNameFilterFn
  },
  {
    accessorKey: "deliveryAddressDetails.pinCode",
    header: "PinCode", //t("addBusiness.parent"),
    // filterFn: firstNameFilterFn
  },
  {
    accessorKey: "deliveryAddressDetails.timing.startDate",
    header: "StartDate", //t("addBusiness.parent"),
    // filterFn: firstNameFilterFn
  },
  {
    accessorKey: "deliveryAddressDetails.timing.deliveryTime",
    header: "Delivery time", //t("addBusiness.parent"),
    // filterFn: firstNameFilterFn
  },

  {
    accessorKey: "action",
    header: t("OrdersTableText.Action"),
    cell: ({ row }) => {
      // <button onClick={() => navigateCallback(row.original.orderId)}>
      //     Go to Details
      // </button>
      const companyRowData = row.original;
      console.log(
        "------------------------------------------------------------",
        row.original
      );
      return (
        <div className="d-flex clays-sm">
          {/* <button
            className="icon-clay"
            onClick={() => acticeViewFun(companyRowData.companyId)}
          >
            <span className="inner-clay color-black">
              <img src={eyeIcon} alt="View" />
            </span>
          </button>
          <button
            className="icon-clay delete"
            onClick={() =>
              onDeleteCompnyBtnClick(companyRowData.companyId, "delete")
            }
            title="Delete Company"
          >
            <img src={deleteIcon} alt="Delete" />
          </button> */}
          <DeclineModalCompanyComponent
            isOpen={isCancelModalOpen}
            onClose={() => onClose}
            orderId={row.original.companyId}
            forModule="Orders"
          />
          {/* <button className="icon-clay">
            <span className="inner-clay color-red"><img src={xIcon} alt="Delete" /></span>
          </button>*/}
        </div>
      );
    },
  },
];

export { ActiveCompanyColumns, PendingCompanyColumns, ParentCompanyColumns }